import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { WorkflowConfigurationService } from "../services/workflowconfiguration.service";
import { Observable } from "rxjs";
import { IWorkflow } from "../interfaces/iworkflow";

@Injectable()
export class DefaultWorkflowConfigurationResolver implements Resolve<IWorkflow> {
    constructor(private workflowConfigurationService: WorkflowConfigurationService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IWorkflow> {
        return this.workflowConfigurationService.getWorkflowConfiguration("DEFAULT");
    }
}
